import {NgModule} from '@angular/core';
import {BrowserModule, Title} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatFormFieldModule} from "@angular/material/form-field";
import {ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatRadioModule} from "@angular/material/radio";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule} from "@angular/material/dialog";
import {SubscriptionComponent} from "./subscription/subscription.component";
import {NotificationService} from "./shared/services/notification.service";
import {SnackbarComponent} from "./shared/components/snackbar/snackbar.component";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {AuthService} from "./shared/services/auth.service";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {CanActivateLoggedIn} from "./shared/activation/can-activate-logged-in";
import {PersonalInfoComponent} from "./personal-info/personal-info.component";
import {AccountService} from "./shared/services/account.service";
import {MatDividerModule} from "@angular/material/divider";
import {SettingsService} from "./shared/services/settings.service";
import {LanguagesResolver} from "./shared/resolvers/languages.resolver";
import {CountriesResolver} from "./shared/resolvers/countries.resolver";
import {MatTabsModule} from "@angular/material/tabs";
import {HomeComponent} from "./home/home.component";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ProfilePictureComponent} from "./profile-picture/profile-picture.component";
import {PasswordChangeComponent} from "./password-change/password-change.component";
import {environment} from "../environments/environment";
import {RedeemVoucherComponent} from "./redeem-voucher/redeem-voucher.component";
import {LocusStoreService} from "./shared/services/locus-store.service";
import {RedeemVoucherLocoinComponent} from "./redeem-voucher/redeem-voucher-locoin/redeem-voucher-locoin.component";
import {MatStepperModule} from "@angular/material/stepper";
import {RedeemVoucherPremiumComponent} from "./redeem-voucher/redeam-voucher-premium/redeem-voucher-premium.component";
import {AccountDeletionComponent} from "./account-deletion/account-deletion.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SignInMethodsComponent} from "./sign-in-methods/sign-in-methods.component";
import {EmailPasswordLinkFormComponent} from "./sign-in-methods/email-password-link-form/email-password-link-form.component";
import {ChangeEmailFormComponent} from "./sign-in-methods/change-email-form/change-email-form.component";
import {ChangePasswordFormComponent} from "./sign-in-methods/change-password-form/change-password-form.component";
import {initializeApp, provideFirebaseApp} from "@angular/fire/app";
import {getAuth, provideAuth} from "@angular/fire/auth";
import {CommunicationComponent} from "./communication/communication.component";
import { SelectContactEmailDialogComponent } from "./sign-in-methods/select-contact-email-dialog/select-contact-email-dialog.component";
import { ConfirmationDialogComponent } from "./shared/components/confirmation-dialog/confirmation-dialog.component";
import { EmailVerificationInterceptor } from "./shared/interceptors/email-verification.interceptor";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { PasswordReauthDialogComponent } from "./sign-in-methods/password-reauth-dialog/password-reauth-dialog.component";
import { SsoReauthConfirmationDialogComponent } from "./sign-in-methods/sso-reauth-confirmation-dialog/sso-reauth-confirmation-dialog.component";
import { ForceReloginDialogComponent } from "./sign-in-methods/force-relogin-dialog/force-relogin-dialog.component";

@NgModule({
  declarations: [
    AppComponent,
    PersonalInfoComponent,
    SubscriptionComponent,
    SnackbarComponent,
    ProfilePictureComponent,
    HomeComponent,
    PasswordChangeComponent,
    RedeemVoucherComponent,
    RedeemVoucherLocoinComponent,
    RedeemVoucherPremiumComponent,
    AccountDeletionComponent,
    SignInMethodsComponent,
    EmailPasswordLinkFormComponent,
    ChangeEmailFormComponent,
    ChangePasswordFormComponent,
    CommunicationComponent,
    SelectContactEmailDialogComponent,
    ConfirmationDialogComponent,
    PasswordReauthDialogComponent,
    SsoReauthConfirmationDialogComponent,
    ForceReloginDialogComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatDividerModule,
    MatTabsModule,
    MatTooltipModule,
    MatStepperModule,
    MatCheckboxModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
  ],
  providers: [
    AccountService,
    AuthService,
    NotificationService,
    CanActivateLoggedIn,
    SettingsService,
    Title,
    LanguagesResolver,
    CountriesResolver,
    LocusStoreService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EmailVerificationInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
